import { SelectContent } from "./primitives/select-content";
import { SelectGroup } from "./primitives/select-group";
import { SelectItem } from "./primitives/select-item";
import { SelectLabel } from "./primitives/select-label";
import {
  SelectScrollDownButton,
  SelectScrollUpButton,
} from "./primitives/select-scroll-buttons";
import { SelectSeparator } from "./primitives/select-separator";
import { SelectTrigger } from "./primitives/select-trigger";
import { SelectValue } from "./primitives/select-value";
import { SelectRoot } from "./select-root";
import type { SelectProps } from "./types";

const Select = (props: SelectProps) => {
  return <SelectRoot {...props} />;
};

export type { SelectProps, SelectRootProps } from "./types";
export {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
};
